//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export abstract class BaseClient {
  transformResult(_url: string, _response: Response, processor: (_response: Response) => Promise<void | any>) {
    const { status } = _response;
    if (status === INTERGTRATION_API_ERROR_CDOE) {
      _response
        .clone()
        .text()
        .then((_responseText) => {
          const result = JSON.parse(_responseText) as IntegrationApiErrorRespponse;
          document.dispatchEvent(
            new CustomEvent<IntegrationApiErrorRespponse>(INTERGTRATION_API_ERROR_NOTIFICATION, { detail: result }),
          );

          return _responseText;
        })
        .catch((error) => {
          console.error(error);
        });
    }

    return processor(_response);
  }
}

export interface IAICodingClient {

    getAICodingJobs(projectId: string | null, versionId: string | null | undefined, version: string | null): Promise<AICodingJobDto[]>;

    getAICodingJobDetails(jobConfigId: number, version: string | null): Promise<AICodingJobDetailsDto>;

    createAICodingJob(version: string | null, command: CreateAICodingJobCommand): Promise<JobConfigIdDto>;

    executeAICodingJob(version: string | null, command: ExecuteAICodingJobCommand): Promise<AICodingExecuteResultDto>;

    getAICodingExecutionStatus(token: string | null, version: string | null): Promise<AICodingExecutionStatusDto>;

    getAICodingCodeframe(jobConfigId: number, version: string | null): Promise<CodeframeItemDto[]>;

    downloadCodeframe(jobConfigId: number, version: string | null): Promise<FileResponse>;

    downloadCodeframeResults(jobConfigId: number, version: string | null): Promise<FileResponse>;

    getCodeframeCodedCount(jobConfigId: number, version: string | null): Promise<number>;
}

export class AICodingClient extends BaseClient implements IAICodingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAICodingJobs(projectId: string | null, versionId: string | null | undefined, version: string | null): Promise<AICodingJobDto[]> {
        let url_ = this.baseUrl + "/api/v{version}/aicoding/jobs/{projectId}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (versionId !== undefined && versionId !== null)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAICodingJobs(_response));
        });
    }

    protected processGetAICodingJobs(response: Response): Promise<AICodingJobDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AICodingJobDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AICodingJobDto[]>(null as any);
    }

    getAICodingJobDetails(jobConfigId: number, version: string | null): Promise<AICodingJobDetailsDto> {
        let url_ = this.baseUrl + "/api/v{version}/aicoding/job/{jobConfigId}";
        if (jobConfigId === undefined || jobConfigId === null)
            throw new Error("The parameter 'jobConfigId' must be defined.");
        url_ = url_.replace("{jobConfigId}", encodeURIComponent("" + jobConfigId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAICodingJobDetails(_response));
        });
    }

    protected processGetAICodingJobDetails(response: Response): Promise<AICodingJobDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AICodingJobDetailsDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AICodingJobDetailsDto>(null as any);
    }

    createAICodingJob(version: string | null, command: CreateAICodingJobCommand): Promise<JobConfigIdDto> {
        let url_ = this.baseUrl + "/api/v{version}/aicoding";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateAICodingJob(_response));
        });
    }

    protected processCreateAICodingJob(response: Response): Promise<JobConfigIdDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JobConfigIdDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobConfigIdDto>(null as any);
    }

    executeAICodingJob(version: string | null, command: ExecuteAICodingJobCommand): Promise<AICodingExecuteResultDto> {
        let url_ = this.baseUrl + "/api/v{version}/aicoding/execute";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExecuteAICodingJob(_response));
        });
    }

    protected processExecuteAICodingJob(response: Response): Promise<AICodingExecuteResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AICodingExecuteResultDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AICodingExecuteResultDto>(null as any);
    }

    getAICodingExecutionStatus(token: string | null, version: string | null): Promise<AICodingExecutionStatusDto> {
        let url_ = this.baseUrl + "/api/v{version}/aicoding/execute/status/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAICodingExecutionStatus(_response));
        });
    }

    protected processGetAICodingExecutionStatus(response: Response): Promise<AICodingExecutionStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AICodingExecutionStatusDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AICodingExecutionStatusDto>(null as any);
    }

    getAICodingCodeframe(jobConfigId: number, version: string | null): Promise<CodeframeItemDto[]> {
        let url_ = this.baseUrl + "/api/v{version}/aicoding/job/{jobConfigId}/codeframe";
        if (jobConfigId === undefined || jobConfigId === null)
            throw new Error("The parameter 'jobConfigId' must be defined.");
        url_ = url_.replace("{jobConfigId}", encodeURIComponent("" + jobConfigId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAICodingCodeframe(_response));
        });
    }

    protected processGetAICodingCodeframe(response: Response): Promise<CodeframeItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CodeframeItemDto[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CodeframeItemDto[]>(null as any);
    }

    downloadCodeframe(jobConfigId: number, version: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/aicoding/job/{jobConfigId}/download-codeframe";
        if (jobConfigId === undefined || jobConfigId === null)
            throw new Error("The parameter 'jobConfigId' must be defined.");
        url_ = url_.replace("{jobConfigId}", encodeURIComponent("" + jobConfigId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadCodeframe(_response));
        });
    }

    protected processDownloadCodeframe(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadCodeframeResults(jobConfigId: number, version: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v{version}/aicoding/job/{jobConfigId}/download-codeframe-results";
        if (jobConfigId === undefined || jobConfigId === null)
            throw new Error("The parameter 'jobConfigId' must be defined.");
        url_ = url_.replace("{jobConfigId}", encodeURIComponent("" + jobConfigId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadCodeframeResults(_response));
        });
    }

    protected processDownloadCodeframeResults(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCodeframeCodedCount(jobConfigId: number, version: string | null): Promise<number> {
        let url_ = this.baseUrl + "/api/v{version}/aicoding/job/{jobConfigId}/codeframe-coded-count";
        if (jobConfigId === undefined || jobConfigId === null)
            throw new Error("The parameter 'jobConfigId' must be defined.");
        url_ = url_.replace("{jobConfigId}", encodeURIComponent("" + jobConfigId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCodeframeCodedCount(_response));
        });
    }

    protected processGetCodeframeCodedCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IDataEncodingClient {

    triggerEncoding(version: string | null, command: TriggerEncodingCommand): Promise<void>;

    getEncodingStatusByProjectId(projectId: string | null, encodingType: DataEncodingType, version: string | null): Promise<EncodingTriggerStatusDto>;

    updateEncodingStatus(version: string | null, command: UpdateEncodingStatusCommand): Promise<TriggeredEncodingStatusDto>;

    getEncodingStatus(token: string | null | undefined, version: string | null): Promise<TriggeredEncodingStatusDto>;

    initiateEncodingDownload(version: string | null, command: InitiateEncodingDownloadCommand): Promise<InitiateDownloadResultDto>;

    getDownloadStatus(token: string | null | undefined, version: string | null): Promise<DownloadStatusDto>;

    getDownloadUrl(token: string | null, version: string | null): Promise<DownloadUrlDto>;

    materializedPipeline(version: string | null, materializedPipelineCommand: MaterializedPipelineCommand): Promise<MaterializeDto>;
}

export class DataEncodingClient extends BaseClient implements IDataEncodingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    triggerEncoding(version: string | null, command: TriggerEncodingCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/v{version}/dataencoding/create";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTriggerEncoding(_response));
        });
    }

    protected processTriggerEncoding(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getEncodingStatusByProjectId(projectId: string | null, encodingType: DataEncodingType, version: string | null): Promise<EncodingTriggerStatusDto> {
        let url_ = this.baseUrl + "/api/v{version}/dataencoding/{projectId}/{encodingType}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (encodingType === undefined || encodingType === null)
            throw new Error("The parameter 'encodingType' must be defined.");
        url_ = url_.replace("{encodingType}", encodeURIComponent("" + encodingType));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEncodingStatusByProjectId(_response));
        });
    }

    protected processGetEncodingStatusByProjectId(response: Response): Promise<EncodingTriggerStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingTriggerStatusDto;
            return result200;
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingTriggerStatusDto>(null as any);
    }

    updateEncodingStatus(version: string | null, command: UpdateEncodingStatusCommand): Promise<TriggeredEncodingStatusDto> {
        let url_ = this.baseUrl + "/api/v{version}/dataencoding/update";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateEncodingStatus(_response));
        });
    }

    protected processUpdateEncodingStatus(response: Response): Promise<TriggeredEncodingStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TriggeredEncodingStatusDto;
            return result200;
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TriggeredEncodingStatusDto>(null as any);
    }

    getEncodingStatus(token: string | null | undefined, version: string | null): Promise<TriggeredEncodingStatusDto> {
        let url_ = this.baseUrl + "/api/v{version}/dataencoding/status?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEncodingStatus(_response));
        });
    }

    protected processGetEncodingStatus(response: Response): Promise<TriggeredEncodingStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TriggeredEncodingStatusDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TriggeredEncodingStatusDto>(null as any);
    }

    initiateEncodingDownload(version: string | null, command: InitiateEncodingDownloadCommand): Promise<InitiateDownloadResultDto> {
        let url_ = this.baseUrl + "/api/v{version}/dataencoding/download";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInitiateEncodingDownload(_response));
        });
    }

    protected processInitiateEncodingDownload(response: Response): Promise<InitiateDownloadResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InitiateDownloadResultDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InitiateDownloadResultDto>(null as any);
    }

    getDownloadStatus(token: string | null | undefined, version: string | null): Promise<DownloadStatusDto> {
        let url_ = this.baseUrl + "/api/v{version}/dataencoding/download/status?";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDownloadStatus(_response));
        });
    }

    protected processGetDownloadStatus(response: Response): Promise<DownloadStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadStatusDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadStatusDto>(null as any);
    }

    getDownloadUrl(token: string | null, version: string | null): Promise<DownloadUrlDto> {
        let url_ = this.baseUrl + "/api/v{version}/dataencoding/download/url/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDownloadUrl(_response));
        });
    }

    protected processGetDownloadUrl(response: Response): Promise<DownloadUrlDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadUrlDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadUrlDto>(null as any);
    }

    materializedPipeline(version: string | null, materializedPipelineCommand: MaterializedPipelineCommand): Promise<MaterializeDto> {
        let url_ = this.baseUrl + "/api/v{version}/dataencoding/materialized-pipeline";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(materializedPipelineCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMaterializedPipeline(_response));
        });
    }

    protected processMaterializedPipeline(response: Response): Promise<MaterializeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaterializeDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaterializeDto>(null as any);
    }
}

export interface IDatasetClient {

    getAllDatasets(version: string | null): Promise<DatasetDto[]>;

    getAllShortDatasets(version: string | null): Promise<ShortDatasetDto[]>;
}

export class DatasetClient extends BaseClient implements IDatasetClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllDatasets(version: string | null): Promise<DatasetDto[]> {
        let url_ = this.baseUrl + "/api/v{version}/dataset/get-all";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllDatasets(_response));
        });
    }

    protected processGetAllDatasets(response: Response): Promise<DatasetDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DatasetDto[];
            return result200;
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DatasetDto[]>(null as any);
    }

    getAllShortDatasets(version: string | null): Promise<ShortDatasetDto[]> {
        let url_ = this.baseUrl + "/api/v{version}/dataset/get-all-shortdatasets";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllShortDatasets(_response));
        });
    }

    protected processGetAllShortDatasets(response: Response): Promise<ShortDatasetDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShortDatasetDto[];
            return result200;
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShortDatasetDto[]>(null as any);
    }
}

export interface IRelevancyCheckerClient {

    startRelevancyCheckerJob(version: string | null, command: RunRelevancyCheckerCommand): Promise<RelevancyCheckerDto>;

    getRelevancyCheckerJobStatus(token: string | null, version: string | null): Promise<RelevancyCheckerStatusDto>;
}

export class RelevancyCheckerClient extends BaseClient implements IRelevancyCheckerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    startRelevancyCheckerJob(version: string | null, command: RunRelevancyCheckerCommand): Promise<RelevancyCheckerDto> {
        let url_ = this.baseUrl + "/api/v{version}/relevancychecker/jobs";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStartRelevancyCheckerJob(_response));
        });
    }

    protected processStartRelevancyCheckerJob(response: Response): Promise<RelevancyCheckerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RelevancyCheckerDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RelevancyCheckerDto>(null as any);
    }

    getRelevancyCheckerJobStatus(token: string | null, version: string | null): Promise<RelevancyCheckerStatusDto> {
        let url_ = this.baseUrl + "/api/v{version}/relevancychecker/status/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRelevancyCheckerJobStatus(_response));
        });
    }

    protected processGetRelevancyCheckerJobStatus(response: Response): Promise<RelevancyCheckerStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RelevancyCheckerStatusDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RelevancyCheckerStatusDto>(null as any);
    }
}

export interface ISimilarityClient {

    startSimilarityCheckerJob(version: string | null, command: RunSimilarityCommand): Promise<string>;

    updateSimilarityCheckerJobStatus(version: string | null, command: UpdateRunSimilarityStatusCommand): Promise<SimilarityReportHistoryDto>;

    getSimilarityCheckerJobStatus(token: string | null, version: string | null): Promise<SimilarityReportStatusDto>;
}

export class SimilarityClient extends BaseClient implements ISimilarityClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    startSimilarityCheckerJob(version: string | null, command: RunSimilarityCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/v{version}/similarity/jobs";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStartSimilarityCheckerJob(_response));
        });
    }

    protected processStartSimilarityCheckerJob(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    updateSimilarityCheckerJobStatus(version: string | null, command: UpdateRunSimilarityStatusCommand): Promise<SimilarityReportHistoryDto> {
        let url_ = this.baseUrl + "/api/v{version}/similarity";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSimilarityCheckerJobStatus(_response));
        });
    }

    protected processUpdateSimilarityCheckerJobStatus(response: Response): Promise<SimilarityReportHistoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimilarityReportHistoryDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimilarityReportHistoryDto>(null as any);
    }

    getSimilarityCheckerJobStatus(token: string | null, version: string | null): Promise<SimilarityReportStatusDto> {
        let url_ = this.baseUrl + "/api/v{version}/similarity/status/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSimilarityCheckerJobStatus(_response));
        });
    }

    protected processGetSimilarityCheckerJobStatus(response: Response): Promise<SimilarityReportStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimilarityReportStatusDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimilarityReportStatusDto>(null as any);
    }
}

export interface ITextVariablesClient {

    getTextVariables(projectId: string | null, versionId: string | null, version: string | null): Promise<TextVariableDto[]>;
}

export class TextVariablesClient extends BaseClient implements ITextVariablesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTextVariables(projectId: string | null, versionId: string | null, version: string | null): Promise<TextVariableDto[]> {
        let url_ = this.baseUrl + "/api/v{version}/textvariables/{projectId}/{versionId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTextVariables(_response));
        });
    }

    protected processGetTextVariables(response: Response): Promise<TextVariableDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TextVariableDto[];
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TextVariableDto[]>(null as any);
    }
}

export interface AICodingJobDto {
    jobConfigId?: number;
    jobConfigUuid?: string;
    requestId?: string;
    encodingId?: number;
    encodingVersion?: string;
    jobTypeName?: string;
    jobVariableId?: number;
    variableName?: string;
    variableReportingName?: string;
    jobStatusName?: string | undefined;
    startedDate?: string | undefined;
    finishedDate?: string | undefined;
    jobMessage?: string | undefined;
    createdDate?: string;
}

export interface ErrorResponse {
    errorMessage?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;
}

export interface EncodingApiErrorResponse extends ErrorResponse {
    request: string;
    response: string;
    url?: string | undefined;
}

export interface AICodingJobDetailsDto {
    codeframe?: Codeframe | undefined;
    jobConfig?: JobConfigDto;
    variables?: JobVariable[];
    executions?: JobExecution[];
}

export interface Codeframe {
    codeframeId?: number;
    codes?: CodeframeCode[];
}

export interface CodeframeCode {
    codeId?: number;
    isBrand?: boolean;
    codeName?: string;
    codeLabel?: string;
    description?: string;
}

export interface JobConfigDto {
    jobConfigId?: number;
    jobConfigUuid?: string;
    requestId?: string;
    jobType?: JobType;
    encoding?: EncodingInfo;
    createdTs?: string;
    createdBy?: string;
}

export enum JobType {
    BrandCoding = "BrandCoding",
    NonBrandCoding = "NonBrandCoding",
    Relevancy = "Relevancy",
    Translation = "Translation",
}

export interface EncodingInfo {
    projectId?: string;
    encodingId?: number;
    encodingVersion?: number;
}

export interface JobVariable {
    jobVariableId?: number;
    variableName?: string;
    variableReportingName?: string;
    questionLabel?: string;
    params?: VariableParams;
    createdTs?: string;
    battery?: string | undefined;
}

export interface VariableParams {
    isHCode?: boolean;
    isTranslate?: boolean;
    isMultiCode?: boolean;
    codingType?: CodingType;
    translationEngine?: string | undefined;
    hCodeVariableField?: string | undefined;
    filters?: string | undefined;
}

export enum CodingType {
    BrandCoding = "BrandCoding",
    NonBrandCoding = "NonBrandCoding",
}

export interface JobExecution {
    jobVariableId?: number;
    status?: JobStatus | undefined;
    startedTs?: string | undefined;
    finishedTs?: string | undefined;
    jobMessage?: string | undefined;
}

export enum JobStatus {
    Queued = "Queued",
    Running = "Running",
    Succeeded = "Succeeded",
    Failed = "Failed",
}

export interface JobConfigIdDto {
    jobConfigId?: number;
}

export interface CreateAICodingJobCommand {
    workdayId?: string | undefined;
    workdayProjectName?: string | undefined;
    originProjectId: string;
    originProjectName: string;
    encodingVersionId: number;
    jobTypeName: JobType;
    jobTypeDescription?: string;
    aiCodingVariables: AICodingVariable[];
    isMultiCode: boolean;
    maxMultiCodes?: number | undefined;
    codingType: CodingType;
    isTranslate: boolean;
    translationEngine?: TranslationEngine | undefined;
    filters?: string | undefined;
}

export interface AICodingVariable {
    variableName: string;
    variableReportingName: string;
    questionLabel: string;
    battery?: string | undefined;
}

export enum TranslationEngine {
    Google = "Google",
    OpenAI = "OpenAI",
}

export interface AICodingExecuteResultDto {
    token?: string;
}

export interface ExecuteAICodingJobCommand {
    jobConfigId?: number;
    jobSubmissionType?: string;
    threshold?: number;
}

export interface AICodingExecutionStatusDto {
    status?: AICodingExecutionStatuses;
    message?: string;
}

export enum AICodingExecutionStatuses {
    InProgress = "InProgress",
    Failed = "Failed",
    Complete = "Complete",
    Unknown = "Unknown",
}

export interface CodeframeItemDto {
    codeName?: string;
    codeLabel?: string;
    codeDescription?: string | undefined;
    count?: number | undefined;
}

export interface Exception {
    Message?: string;
    InnerException?: Exception | undefined;
    Source?: string | undefined;
    StackTrace?: string | undefined;
}

export interface BusinessException extends Exception {
}

export interface TriggerEncodingCommand {
    projectId: string;
    includeNonComplete?: boolean;
    stackedVariableName?: string | undefined;
}

export interface EncodingTriggerStatusDto {
    token: string;
    status: PollingStatuses;
    createdAt: string;
    finishedAt?: string;
    errorMessage?: string;
    isStacked: boolean;
}

export enum PollingStatuses {
    InProgress = "InProgress",
    Complete = "Complete",
    Failed = "Failed",
    Unknown = "Unknown",
}

export enum DataEncodingType {
    Encoding = "Encoding",
    MaterializedPipeline = "MaterializedPipeline",
}

export interface TriggeredEncodingStatusDto {
    status: PollingStatuses;
    stage?: string;
    message?: string;
    lastUpdateReceived?: string;
}

export interface UpdateEncodingStatusCommand {
    token: string;
    status: PollingStatuses;
    errorMessage?: string;
}

export interface InitiateDownloadResultDto {
    token?: string;
}

export interface InitiateEncodingDownloadCommand {
    projectId: string;
    source: string;
    version: string;
    includeEmptyVariables?: boolean;
    fileType?: string;
    instructionsName?: string;
    stackingName?: string;
    fileSet?: string[];
    extension: string;
    concatenateHeaders?: boolean;
    dataColumnsKeep?: string[];
    dictionaryColumnsKeep?: string[];
    zerofill?: boolean;
    filters?: any[];
}

export interface DownloadStatusDto {
    status?: string;
    message?: string;
}

export interface DownloadUrlDto {
    presignedUrl?: string;
}

export interface MaterializeDto {
    token: string;
    status: PollingStatuses;
    message?: string;
    errorMessage?: string;
}

export interface MaterializedPipelineCommand {
    originProjectId: string;
    encodingVersionId: string;
}

export interface DatasetDto {
    id: string;
    name?: string | undefined;
    source: string;
    businessUnit?: string | undefined;
    dateCreated?: string | undefined;
    encodedDate?: string | undefined;
    totalEncodings: number;
}

export interface ShortDatasetDto {
    id?: string;
    source?: string;
    totalEncodings?: number;
    lastEncodedDate?: string | undefined;
    encodingIds?: string[];
}

export interface RelevancyCheckerDto {
    token: string;
    variableName: string;
    message?: string;
}

export interface RunRelevancyCheckerCommand {
    projectId: string;
    version: string;
    variableName: string;
    englishOnly?: boolean;
}

export interface RelevancyCheckerStatusDto {
    message: string;
    status: RelevancyCheckerStatuses;
}

export enum RelevancyCheckerStatuses {
    InProgress = "InProgress",
    Failed = "Failed",
    Complete = "Complete",
    Unknown = "Unknown",
}

export interface RunSimilarityCommand {
    id: number;
    originProjectId: string;
    encodingVersionId: string;
    variable?: string;
    categories?: number[];
    timeAnalysis?: boolean;
    similarityVariables?: SimilarityVariable[];
    weights: { [key in keyof typeof DataTypes]?: number; };
    filters?: string;
}

export interface SimilarityVariable {
    name: string;
    dataType: DataTypes;
}

export enum DataTypes {
    Categorical = "Categorical",
    Numeric = "Numeric",
    Date = "Date",
    Text = "Text",
}

export interface SimilarityReportHistoryDto {
    projectId?: number;
    encodingVersionId?: string;
    modificationId?: number | undefined;
    token: string;
    status: SimilarityReportStatuses;
    errorMessage?: string;
    createdAt: string;
    finishedAt?: string;
    similarityFormData?: SimilarityFormData;
}

export enum SimilarityReportStatuses {
    InProgress = "InProgress",
    Failed = "Failed",
    Complete = "Complete",
    Unknown = "Unknown",
}

export interface SimilarityFormData {
    variable?: string;
    categories?: number[];
    similarityVariables?: SimilarityVariable[];
    weights?: { [key in keyof typeof DataTypes]?: number; };
    filters?: string;
}

export interface UpdateRunSimilarityStatusCommand {
    token: string;
    status: SimilarityReportStatuses;
    errorMessage?: string;
}

export interface SimilarityReportStatusDto {
    message: string;
    status: SimilarityReportStatuses;
}

export interface TextVariableDto {
    variableFullName?: string;
    variableLabel?: string;
    isRespondable?: boolean;
    battery?: string;
    nonEmptyCount?: number;
    nonEmptyCountPercentage?: number;
    translatedCount?: number;
    variableName?: string;
    isEdited?: boolean;
    datatype?: DataTypes;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

const INTERGTRATION_API_ERROR_CDOE = 527;
export const INTERGTRATION_API_ERROR_NOTIFICATION = "LRWApiErrorNotification";

export type IntegrationApiErrorRespponse = {
  response: string;
  request: string;
  errorMessage: string;
  url?: string;
};